<template>
  <div class="wa-step wa-step--wide">
    <h2 class="wa-step__heading">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.heading') }}
    </h2>
    <p class="wa-step__lead">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.lead') }}
    </p>
    <div
      class="wa-number-options"
      role="group"
      :aria-label="t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.optionsAriaLabel')"
    >
      <article class="wa-number-option">
        <div
          class="wa-number-option__index"
          aria-hidden="true"
        >
          1
        </div>
        <div class="wa-number-option__body">
          <div class="wa-number-option__header">
            <span class="wa-number-option__icon wa-number-option__icon--phone">
              <i class="fa-solid fa-phone" />
            </span>
            <div class="wa-number-option__titles">
              <h3 class="wa-number-option__title">
                {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option1Title') }}
              </h3>
              <span class="wa-number-option__tag">
                {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option1Tag') }}
              </span>
            </div>
          </div>
          <ul class="wa-number-option__list">
            <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option1Bullet1') }}</li>
            <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option1Bullet2') }}</li>
            <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option1Bullet3') }}</li>
          </ul>
        </div>
      </article>

      <div
        class="wa-number-options__divider"
        aria-hidden="true"
      >
        <span>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.or') }}</span>
      </div>

      <article class="wa-number-option">
        <div
          class="wa-number-option__index"
          aria-hidden="true"
        >
          2
        </div>
        <div class="wa-number-option__body">
          <div class="wa-number-option__header">
            <span class="wa-number-option__icon wa-number-option__icon--meta">
              <i class="fa-brands fa-meta" />
            </span>
            <div class="wa-number-option__titles">
              <h3 class="wa-number-option__title">
                {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option2Title') }}
              </h3>
              <span class="wa-number-option__tag">
                {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option2Tag') }}
              </span>
            </div>
          </div>
          <ul class="wa-number-option__list">
            <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option2Bullet1') }}</li>
            <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option2Bullet2') }}</li>
            <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.none.numberChoice.option2Bullet3') }}</li>
          </ul>
        </div>
      </article>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'WhatsappNumberChoiceStep',

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
